export default __webpack_public_path__ + "static/media/rhenus-cat.85b6a53d.svg";